import { connect } from 'react-redux';
import React from 'react';
import { bindActionCreators } from 'redux';
import routerActions from 'app/routerActions';
import * as valid from 'utils/validate';
import { KBForm, KBButton } from 'components';
import { CONTACTS_IDCARD_TYPE } from 'app/constants';
import { renderKBInput, renderKBSelect, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';

var OrgManagerForm = class extends React.Component {constructor(props) {super(props);this.state = this.getInitialState();this.saveOrgManagerOfNext = this.saveOrgManagerOfNext.bind(this);this.saveOrgManagerOfComplete = this.saveOrgManagerOfComplete.bind(this);this.saveOrgManagerOfLast = this.saveOrgManagerOfLast.bind(this);}getInitialState()
  {
    return {
      formSubmitting: this.props.formSubmitting };

  }componentDidMount()

  {}componentDidUpdate(prevProps) {
    if (this.props.formSubmitting !== prevProps.formSubmitting) {
      this.setState({
        formSubmitting: this.props.formSubmitting });

    }
  }saveOrgManagerOfNext(

  model) {
    const { saveParams, isUpdate, formSubmitting } = this.props;
    // !formSubmitting && saveParams && saveParams(model, 3)
    if (isUpdate) {
      return !formSubmitting && saveParams && saveParams(model, 3);
    }
    saveParams && saveParams(model, 3, false, true);
    // saveParams && saveParams(model, 3, true, true)
  }saveOrgManagerOfComplete(

  model) {
    const { saveParams, isUpdate } = this.props;
    if (isUpdate) {
      return saveParams && saveParams(model, false, true);
    }
    saveParams && saveParams(model, false, true);
  }saveOrgManagerOfLast()

  {
    const { fields, saveParams } = this.props;
    let model = {};
    Object.keys(fields).map(field_key => {
      model[field_key] = fields[field_key].value;
    });
    saveParams && saveParams(model, 1);
  }render()

  {
    const {
      fields: {
        contacts_name,
        contacts_phone,
        contacts_idcard_type,
        contacts_id_number,
        org_contacts_phone,
        contacts_email } } =

    this.props;
    const { handleSubmit, isUpdate, isOCRM } = this.props;
    const { formSubmitting } = this.state;

    return (
      <KBForm type="reduxForm">
        <header className="kb-form-header">
          <h2 className="header-title">公司负责人</h2>
        </header>
        <div className="kb-form-container">
          <div className="kb-row kb-form-48">
            <Field name="contacts_name" component={renderKBInput}
            className="kb-form-group kb-div-39"
            title="姓名"
            />

            <div className="kb-row kb-form-66" style={{ float: 'left' }}>
              <Field name="contacts_phone" component={renderKBInput}
              className="kb-form-group kb-div-48"
              title="联系电话"
              titleClass="label-rt"

              type="text" />

            </div>
          </div>
          <div className="kb-row kb-form-48">
            <Field name="contacts_idcard_type" component={renderKBSelect}
            className="kb-form-group kb-div-39"
            title="证件类型"
            defaultValue="-1"

            arrayData={CONTACTS_IDCARD_TYPE} />

            <div className="kb-row kb-form-66" style={{ float: 'left' }}>
              <Field name="contacts_id_number" component={renderKBInput}
              className="kb-form-group kb-div-48"
              title="证件号码"
              titleClass="label-rt"

              type="text" />

            </div>
          </div>
          <div className="kb-row kb-form-48">
            <Field name="contacts_email" component={renderKBInput}
            className="kb-form-group kb-div-39"
            title="邮箱"
            />

            <div className="kb-row kb-form-66" style={{ float: 'left' }}>
              <Field name="org_contacts_phone" component={renderKBInput}
              className="kb-form-group kb-div-48"
              title="企业电话"
              titleClass="label-rt"

              type="text" />

            </div>
          </div>
          <div className="kb-row">
            <KBButton
            className="certain-btn"
            type="button"
            onClick={this.saveOrgManagerOfLast}>

              上一步
            </KBButton>
            <KBButton
            className="certain-btn"
            type="submit"
            onClick={handleSubmit(this.saveOrgManagerOfNext)}
            submitting={formSubmitting}
            style={{ marginLeft: 30 }}>

              下一步
            </KBButton>
            {!isOCRM &&
            <KBButton
            className="certain-btn"
            type="submit"
            onClick={handleSubmit(this.saveOrgManagerOfComplete)}
            submitting={formSubmitting}
            style={{ marginLeft: 30 }}>

                {isUpdate ? '完成编辑' : '完成添加'}
              </KBButton>}

          </div>
          {!isUpdate ?
          <div
          style={{
            backgroundColor: '#F8FAFC',
            border: '1px solid #DFE3E9',
            borderRadius: 4,
            padding: '20px 24px' }}>


              <p style={{ color: '#333C48' }}>
                点击"完成添加"后, 其他信息可以稍后到公司详情页 -
                点击"编辑"进行补充
              </p>
            </div> :
          null}
        </div>
      </KBForm>);

  }};


function mapStateToProps(state, props) {
  const { org, urlParams } = props;
  const isUpdate = urlParams && urlParams.type === 'update' && org;

  return {
    isUpdate,
    initialValues: org ?
    {
      ...org } :

    {} };

}

function mapDispatchToProps(dispatch) {
  return {
    routerActions: bindActionCreators(routerActions, dispatch) };

}

const validate = values => {
  const errors = {};

  if (values.contacts_phone && valid.isNumber(values.contacts_phone)) {
    errors.contacts_phone = '手机号码只能为数字';
  }

  if (values.contacts_id_number) {
    if (
    values.contacts_idcard_type === 'idcard' &&
    valid.IDCard(values.contacts_id_number))
    {
      errors.contacts_id_number = '请输入18位身份证号码，最后一位x必须大写';
    }

    if (
    values.contacts_idcard_type === 'passport' &&
    valid.passport(values.contacts_id_number))
    {
      errors.contacts_id_number = '请输入正确的护照格式';
    }
  }

  return errors;
};

const LEGACY_FORM_FIELDS = [
  "contacts_name",
  "contacts_phone",
  "contacts_idcard_type",
  "contacts_id_number",
  "org_contacts_phone",
  "contacts_email"
];

const formConfig = {
  form: 'OrgManagerForm',

  validate: validate,
  touchOnBlur: false };


export default connect(mapStateToProps, mapDispatchToProps)(reduxForm(formConfig)(withReduxFormFieldProps('OrgManagerForm', LEGACY_FORM_FIELDS)(OrgManagerForm)));
